'use client';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { getDelegateAccountLabel } from 'src/utils/account';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { cj } from 'src/utils/classNames';
import useModal from 'src/components/Modals/hooks/useModal';
import TopBarWalletButtonIcon from 'src/components/TopBar/TopBarWalletButtonIcon';
import Button from 'src/components/primitives/Button/Button';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { useAppInitialLoadContext } from 'src/providers/app/AppInitialLoadProvider/AppInitialLoadProvider';
import useWalletIdentity from 'src/hooks/wallets/useWalletIdentity';

const DATA_TEST_ID = 'wallet_button';

export default function TopBarWalletButton() {
	const setDrawersState = useDrawersStore((s) => s.set);
	const isAccountsSidebarOpen = useDrawersStore((s) => s.accounts.show);
	const walletIsConnected = useVelocityStore(
		(s) => s.wallet.current?.adapter?.connected
	);
	const walletPubKey = useVelocityStore(
		(s) => s.wallet.current?.adapter?.publicKey
	);
	const currentAccount = useVelocityAccountStore(
		(s) => s.accounts[s.currentUserKey ?? '']
	);
	const identity = useWalletIdentity();
	const { show } = useModal();

	const { isInitialLoading } = useAppInitialLoadContext();

	const handleShowConnectWalletOptions = () => {
		show({ type: 'connect_wallet', props: {} });
	};

	const handleConnectedButtonClick = () => {
		setDrawersState((s) => {
			if (isAccountsSidebarOpen) {
				s.accounts.show = false;
			} else {
				s.accounts.show = true;
			}
		});
	};

	const remountKey = walletIsConnected ? 'connected' : 'disconnected';

	if (!walletIsConnected || !walletPubKey) {
		return (
			<Button
				size="md"
				onClick={handleShowConnectWalletOptions}
				key={remountKey}
				dataTestId={DATA_TEST_ID}
				className={cj(isInitialLoading && 'animate-pulse')}
				disabled={isInitialLoading}
			>
				Connect
			</Button>
		);
	}

	const accountName = currentAccount?.isDelegatedTo
		? getDelegateAccountLabel(currentAccount)
		: (currentAccount?.name ?? '');

	return (
		<Button
			size="md"
			variant="secondary"
			className="h-full gap-x-sm overflow-hidden py-xs"
			onClick={handleConnectedButtonClick}
			dataTestId={DATA_TEST_ID}
			key={remountKey}
		>
			<TopBarWalletButtonIcon />
			<div className="flex flex-col items-start typo-body-2xs text-text-default">
				<span className="max-w-18 truncate whitespace-nowrap">
					{accountName}
				</span>
				<span className="max-w-18 truncate whitespace-nowrap text-text-secondary">
					{identity}
				</span>
			</div>
		</Button>
	);
}
